import React from "react";

const ApprovalPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Approved ✅</h2>
      <p>Purchase Order Created</p>
    </div>
  );
};

export default ApprovalPage;